/* eslint-disable react/forbid-component-props */
import { Field } from 'formik';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { CHECKOUT_PAYMENT_COMPONENT } from '../../../brands/default/content/components/checkout';
import { ECOMMERCE_TERMS } from '../../../brands/default/links';
import ThemeContext from '../../../providers/ThemeProvider';

const PaymentAgreeTerms = ({ disabled }) => {
  const theme = useContext(ThemeContext);
  const agreeLinkHref = disabled ? null : ECOMMERCE_TERMS;
  const agreeLinkText =
    CHECKOUT_PAYMENT_COMPONENT.PaymentAgreeTerms.ecommerceLinkText;

  return (
    <>
      <p>
        <label className="agree-terms-label" htmlFor="confirmPayment">
          {CHECKOUT_PAYMENT_COMPONENT.PaymentAgreeTerms.agreeText}{' '}
          <a
            className="agree-terms-link"
            href={agreeLinkHref}
            rel="noreferrer noopener"
            target="_blank"
          >
            {agreeLinkText}
          </a>
        </label>
        <Field
          className="agree-terms-checkbox"
          data-qa="eCommerceTermsCheck"
          disabled={disabled}
          id="confirmPayment"
          name="confirmPayment"
          type="checkbox"
        />
        <style jsx>{`
          .agree-terms-label {
            font-weight: bold;
          }
          .agree-terms-link {
            color: ${theme.colors.primary};
          }
          .agree-terms-link:hover {
            color: ${theme.colors.checkoutlinkhover};
            text-decoration: underline;
          }
          :global(.agree-terms-checkbox) {
            float: right;
          }
        `}</style>
      </p>
    </>
  );
};

PaymentAgreeTerms.propTypes = {
  disabled: PropTypes.bool,
};

export default PaymentAgreeTerms;
